module.exports = __webpack_public_path__ + "static/media/ipob.e21bc1fe.png";